import React from 'react'
export default function Man({ className, style }) {
  return (
    <svg className={className} width="1em" height="1em" style={{ verticalAlign: '-0.125em', ...style }} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8"
      strokeLinecap="round" strokeLinejoin="round">
      <circle cx="10" cy="14" r="6" />
      <line x1="14.24" y1="9.76" x2="20" y2="4" />
      <polyline points="15 4 20 4 20 9" />
    </svg>
  )
}
